import { render, staticRenderFns } from "./MoveSummary.vue?vue&type=template&id=6e257474&lang=pug"
import script from "./MoveSummary.vue?vue&type=script&lang=ts"
export * from "./MoveSummary.vue?vue&type=script&lang=ts"
import style0 from "./MoveSummary.vue?vue&type=style&index=0&id=6e257474&prod&lang=css&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/app/components/vantone/Icon.vue').default})
